// IDs de GTM para cada tipo de ruta
export const GTM_IDS = {
  CLIENTES: 'GTM-MMZ82RB5',      // Cuando idPaginaPolkista es null/false
  POLKISTAS: 'GTM-MZFRPZJV'      // Cuando idPaginaPolkista existe
};

